import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_3de76d81";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_3de76d81" };
/** script content **/
require("./textarea.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex3de76d81%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Ftextarea%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_3de76d81"],
    ctorType: "component",
    outputPath: "components/index3de76d81/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'mpx-textarea': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-textarea?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
